module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_3016.65d2595c.png";